// A settlement token is exactly 64 hex characters (varchar(64) on the backend).
const SETTLEMENT_TOKEN_PATTERN = /^[0-9a-f]{64}$/i;

// Resolve the PayPal order id (fixed DEFECT-30): a stored order id wins, otherwise
// the URL token is used unless it is a settlement token. Only a full 64-hex token is
// treated as a settlement token — a genuine PayPal order id can be all-hex (and
// short), so the old "any hex" test discarded real order ids.
export const pickPayPalOrderId = (
  storedOrderId: string | null,
  urlToken: string | null
): string | null =>
  storedOrderId || (urlToken && !SETTLEMENT_TOKEN_PATTERN.test(urlToken) ? urlToken : null);

// Build the bank-transfer payment reference: {prefix}{invoice number without its
// own [A-Z]+- prefix}-{invoice code} (DEFECT-1: the backend importer expects an
// extra '-' after the prefix, so this reference cannot be parsed back).
export const buildPaymentReference = (
  prefix: string,
  invoiceNumber: string,
  invoiceCode: string
): string => {
  // Strip the invoice prefix (e.g., 'INV-') from the invoice number
  const referencePrefix = prefix || '';
  const invoiceNumberWithoutPrefix = invoiceNumber.replace(/^[A-Z]+-/, '') || '';
  return `${referencePrefix}${invoiceNumberWithoutPrefix}-${invoiceCode}`;
};

// Format IBAN with spaces every 4 characters for readability
export const formatIban = (iban: string): string => {
  return iban.replace(/\s/g, '').replace(/(.{4})/g, '$1 ').trim();
};

// Sort payment methods by display order, without mutating the input array.
export const sortByDisplayOrder = <T extends { display_order: number }>(methods: T[]): T[] => {
  return [...methods].sort((a, b) => a.display_order - b.display_order);
};
